import React, { useRef, useEffect, useState, useMemo } from "react";
import useCamera from "./hook";
import LoaderLulo from "../../../../components/loaderLulo";
import Loader from "../../../../components/loader";
import InstructionsPopup from "./components/InstructionsPopup";
import "./index.css";
import { useLocation } from "react-router-dom";
import {getBestBackCamera, getCameraCapabilities, getVideoInputs, initDevice} from "../../../../utils/camera-utils";
import {forceFocus, onReportEvent, optimizeImageQuality} from "../../utils";
import { Stream } from "../../utils/helpers/Stream";
import {SDK_EVENT_KEYS} from "../../../../utils/logService";
import EXIF from "exif-js";
import CaptureManual from "./components/CaptureManual";
import ManualCapturePopup from "./components/manualCapturePopup";
import ErrorManualCapturePopup from "./components/errorManualCapturePopup";

export function WrapperCardCaptureV7() {
  const location = useLocation();
  const [config, setConfig] = useState({});
  const [configLoading, setLoading] = useState(true);

  const projectName = useMemo(() => {
    const params = new Proxy(new URLSearchParams(location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });


    const name = params.projectName || "Default";

    return name;
  }, [location.search]);

  const url = () => {
      console.log('projectName', projectName);
    if (location.pathname.includes("card-capture")) {
      return `https://lnesv3-conf.ado-tech.com/${projectName}/CardCapture/config.json`;
    }
    return `https://lnesv3-conf.ado-tech.com/${projectName}/Liveness/config.json`;
  };

  const defaultUrl = () => {
    if (location.pathname.includes("card-capture")) {
      return `https://lnesv3-conf.ado-tech.com/Default/CardCapture/config.json`;
    }
    return `https://lnesv3-conf.ado-tech.com/Default/Liveness/config.json`;
  };

  function setStyles(stylesObject) {
    const root = document.documentElement;
    root.style.setProperty("--background-color", stylesObject.backgroundColor);
    root.style.setProperty("--message-color", stylesObject.messageColor);
    root.style.setProperty("--message-back-color", stylesObject.messageBackgroundColor);
    root.style.setProperty("--guide-color", stylesObject.guideColor);
    root.style.setProperty("--success-color", stylesObject.successColor);
    root.style.setProperty("--error-color", stylesObject.errorColor);
    root.style.setProperty("--message-error-color", stylesObject.messageErrorColor);
    root.style.setProperty("--font-size", stylesObject.fontSize);
  }

  const fetchConfig = async () => {
    try {
      const response = await fetch(url(), { method: "GET" });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setConfig(data);
      setStyles(data.styles);
    } catch (error) {
      const response = await fetch(defaultUrl(), { method: "GET" });
      const data = await response.json();
      setConfig(data);
      setStyles(data.styles);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  if (configLoading) {
    return null;
  }

  return <CardCaptureV7 configLoading={configLoading} configValue={config} />;
}

export default function CardCaptureV7({ configValue, configLoading }) {
  const lottieRef = useRef(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const guideAdo = useRef(null);
  const textPreviewBack = useRef(null);
  const textPreview = useRef(null);
  const imgBack = useRef(null);
  const takeManual = useRef(null);
  const containerAdo = useRef(null);
  const cameraToggle = useRef(null);


  const [isChangingCamera, setIsChangingCamera] = useState(false);
  const [currentCameraIndex, setCurrentCameraIndex] = useState(0);
  const [availableCameras, setAvailableCameras] = useState([]);
  const [showInstructions, setShowInstructions] = useState(false);
  const [hasShownInstructions, setHasShownInstructions] = useState(false);


  const {
    platform,
    loading,
    projectName,
    typeCapture,
    goBack,
      inputRef,
    isMovil,
    takeManualPhoto,
      triggerCamera,
      retryAutomaticCapture,
      handleFileChange,
      showModalCaptureManual,
    emitReadyCam,
    initializeCamera,
    cameraInitialized,
    permissionsGranted,
      openCameraNavite,
      errorCaptureManual,
      setErrorCaptureManual,
      setShowInstructionsCameraNative,
      showInstructionsCameraNative,
  } = useCamera({
    containerAdo,
    configLoading,
    configValue,
    videoRef,
    canvasRef,
    guideAdo,
    textPreviewBack,
    textPreview,
    imgBack,
    takeManual,
    cameraToggle,
  });


  function openPopupCameraManual() {
      if (configValue?.configCamera?.useNativeCamera) {
          setShowInstructionsCameraNative(true);
          return
      }
      // abrir camara manual en UI
      handleInstructionsClose();
  }
  useEffect(() => {
    const animation = lottieRef.current;
    if (animation) {
      animation.setSpeed(2.5);
      animation.play();
    }
  }, []);

  // MODIFICADO: Detectar cámaras después de obtener permisos
  useEffect(() => {
    const getCameras = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const cameras = devices.filter((device) => device.kind === "videoinput");
        const backCameras = cameras.filter((camera) =>
          camera.label.toLowerCase().includes("back") ||
          camera.label.toLowerCase().includes("rear") ||
          camera.label.toLowerCase().includes("trasera")
        );
        const detectedCameras = backCameras.length > 0 ? backCameras : cameras;
        setAvailableCameras(detectedCameras);
        console.log('Cámaras detectadas:', detectedCameras.length, detectedCameras);
      } catch (error) {
        console.error('Error detectando cámaras:', error);
      }
    };

    // Detectar cámaras después de obtener permisos
    if (permissionsGranted) {
      getCameras();
    }
  }, [permissionsGranted]);

  // MODIFICADO: Mostrar popup después de obtener permisos y detectar cámaras
  useEffect(() => {
    if (permissionsGranted && !hasShownInstructions && configValue?.showInstructionsPopup !== false && !cameraInitialized) {
      // Esperar un momento para que se detecten las cámaras
      setTimeout(async () => {
          const videoInputs = await getVideoInputs()
          const cameras = videoInputs.filter((device) => device.kind === "videoinput");
          const backCameras = cameras.filter((camera) =>
              camera.label.toLowerCase().includes("back") ||
              camera.label.toLowerCase().includes("rear") ||
              camera.label.toLowerCase().includes("trasera")
          );

          /*
          const cameraDetail = [];
          for (const camera of cameras) {
              const { capabilities } = await getCameraCapabilities(camera.deviceId)
              cameraDetail.push({
                  camera: camera.label,
                  detail: capabilities
              })
          }
          onReportEvent(SDK_EVENT_KEYS.CameraQualityDetected, {data: JSON.stringify(cameraDetail)}, 'CardCapture').catch()
        */
          const detectedCameras = backCameras.length > 0 ? backCameras : cameras;

          // si solo tiene una camara, no muestra el modal de instructivo
          if (detectedCameras.length === 1) {

              // abre la camara manual
              if (configValue.configCamera?.onlyManual) {
                  openPopupCameraManual()
                  return
              }
              handleInstructionsClose();
          } else {
              if (configValue.configCamera?.onlyManual) {
                  openPopupCameraManual()
                  return
              }
              // muestra el modal de instructivo
              setShowInstructions(detectedCameras.length > 1);
          }
        setHasShownInstructions(true);
      }, 500);
    }
  }, [permissionsGranted, hasShownInstructions, configValue, cameraInitialized]);

  function openCameraManual() {
      setErrorCaptureManual({
          show: false,
          message: ''
      })
      setShowInstructionsCameraNative(true);
      openCameraNavite();
  }
  // MODIFICADO: Función para manejar el cierre del popup e iniciar la cámara
  const handleInstructionsClose = async () => {
    setShowInstructions(false);
    // Iniciar la cámara después de cerrar el popup
    if (initializeCamera) {
      await initializeCamera();
    }
  };

  function closeProcess() {
      goBack();
  }
  useEffect(() => {
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach((track) => {
          track.stop();
          track.enabled = false;
        });
        videoRef.current.srcObject = null;
      }
      if (canvasRef.current) {
        const ctx = canvasRef.current.getContext("2d");
        if (ctx) {
          ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        }
      }
    };
  }, []);

  const handleCameraToggle = async () => {
    if (availableCameras.length <= 1 || isChangingCamera) return;

    const nextIndex = (currentCameraIndex + 1) % availableCameras.length;
    const nextCamera = availableCameras[nextIndex];

    try {
      setIsChangingCamera(true);

      // Pausar detector
      const streamRef = Stream.getInstance();
      if (streamRef) {
        streamRef.pauseStream();
      }

      // Detener tracks actuales
      if (videoRef.current && videoRef.current.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach((track) => {
          track.stop();
          track.enabled = false;
        });
      }

      // Preparar nueva cámara
      const constraints = {
        video: {
          deviceId: { exact: nextCamera.deviceId },
          width: { ideal: 1920 },
          height: { ideal: 1080 },
          frameRate: { ideal: 30 },
        },
      };

      // Obtener nuevo stream
      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      // Configurar video con el nuevo stream
      if (videoRef.current) {
        videoRef.current.srcObject = stream;

        // Esperar a que el video esté listo
        await new Promise((resolve) => {
          videoRef.current.onloadedmetadata = () => {
            videoRef.current.play().then(resolve);
          };
        });

        // Esperar un frame adicional para asegurar que el video está renderizando
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      }

      setCurrentCameraIndex(nextIndex);

      // Actualizar canvas y stream
      if (streamRef && canvasRef.current && videoRef.current) {
        const canvas = canvasRef.current;
        const video = videoRef.current;

        canvas.width = video.videoWidth || 1920;
        canvas.height = video.videoHeight || 1080;

        const ctx = canvas.getContext('2d', {
          alpha: false,
          desynchronized: false,
          willReadFrequently: true
        });
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        streamRef.updateHtmlElements(
          videoRef.current,
          canvasRef.current,
          textPreview.current,
          textPreviewBack.current,
          configValue
        );

        await streamRef.initStream(stream);
      }

      // Delay para que el loader sea visible (1 segundo)
      await new Promise(resolve => setTimeout(resolve, 1000));

      console.log('Cámara cambiada exitosamente');
    } catch (error) {
      console.error('Error al cambiar de cámara:', error);
    } finally {
      setIsChangingCamera(false);
    }
  };

  const handleVideoTap = async (event) => {
    if (initDevice().isIos) {
      event.preventDefault();
      await forceFocus(videoRef);
      await optimizeImageQuality(videoRef);
    }
  };


  return (
    <div
      ref={containerAdo}
      className={`container v6 movil ${
        projectName.toLowerCase().includes("lulo") ? "background-lulo" : "background-default"
      }`}
    >
      {/* MODIFICADO: Loader mientras se piden permisos O mientras se inicializa la cámara */}
      {loading && emitReadyCam !== "true" && (
        <div className="loader-container">
          {projectName.toLowerCase().includes("lulo") ? (
            <LoaderLulo />
          ) : (
            <Loader color="#FFF" primary={configValue?.styles?.loader?.spinnerColor || "#FF3D00"} />
          )}
        </div>
      )}

        <input
            type="file"
            ref={inputRef}
            id="native-camera-input"
            accept="image/*"
            capture="environment"
            onChange={handleFileChange}
            style={{ display: 'none' }}
        />

      {/* MODIFICADO: Popup de instrucciones - se muestra antes de inicializar la cámara */}
      {showInstructions && (
        <InstructionsPopup
          configValue={configValue}
          onClose={handleInstructionsClose}
          showCameraToggle={true}
        />
      )}
        {showInstructionsCameraNative && (
        <ManualCapturePopup
          configValue={configValue}
          closeProcess={closeProcess}
          openCamera={openCameraManual}
        />
      )}
        {errorCaptureManual.show && (
            <ErrorManualCapturePopup
              configValue={configValue}
              errorMessage={errorCaptureManual.message}
              closeProcess={closeProcess}
              openCamera={openCameraManual}
            />
      )}
        {showModalCaptureManual && (
        <CaptureManual
          configValue={configValue}
          tryAutomatic={retryAutomaticCapture}
          goManual={triggerCamera}
        />
      )}

      {/* Loader al cambiar de cámara */}
      {!showInstructions && cameraInitialized && isChangingCamera && (
        <div className="loader-container">
          {projectName.toLowerCase().includes("lulo") ? (
            <LoaderLulo />
          ) : (
            <Loader color="#FFF" primary={configValue?.styles?.loader?.spinnerColor || "#FF3D00"} />
          )}
        </div>
      )}

      {/* MODIFICADO: Componentes siempre montados pero ocultos durante cambio de cámara */}
      {!showInstructions && cameraInitialized && (
        <>
          {availableCameras.length > 1 && configValue?.cameraToggle?.show !== false && (
            <div
              className={`camera-toggle-container ${isChangingCamera ? 'hiding' : ''}`}
              ref={cameraToggle}
            >
              <button className="camera-toggle-button" onClick={handleCameraToggle} disabled={isChangingCamera}>
                <svg width="22" height="22" viewBox="0 0 188 196" xmlns="http://www.w3.org/2000/svg">
                  <g transform="translate(0.000000,196.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                    <path d="M1361 1753 c-20 -80 -55 -128 -113 -157 -28 -14 -60 -26 -69 -26 -9 0 -26 -8 -38 -17 -31 -25 -12 -45 64 -67 80 -24 126 -72 149 -155 27 -98 58 -94 90 12 23 77 68 121 144 143 105 30 109 61 11 88 -86 23 -137 76 -162 164 -15 54 -20 62 -41 62 -20 0 -25 -7 -35 -47z"/>
                    <path d="M498 1440 c-255 -5 -257 -5 -282 -29 -15 -14 -31 -41 -37 -60 -7 -24 -9 -209 -7 -548 3 -499 4 -512 24 -540 11 -15 36 -36 55 -46 32 -17 72 -18 639 -15 668 4 651 2 685 68 23 44 22 561 -1 581 -11 9 -20 10 -32 2 -13 -8 -18 -29 -20 -91 l-3 -82 -109 124 c-116 132 -145 150 -193 124 -14 -7 -102 -104 -196 -215 -94 -111 -181 -209 -193 -217 -37 -26 -72 -19 -139 28 -158 111 -183 126 -210 126 -28 0 -46 -13 -160 -112 l-66 -58 -7 38 c-3 20 -6 211 -6 423 0 354 1 389 18 408 16 19 27 20 277 22 143 1 268 6 278 11 38 19 7 71 -40 66 -10 -1 -134 -5 -275 -8z"/>
                    <path d="M1013 1412 c-6 -4 -19 -26 -28 -50 -20 -48 -65 -90 -107 -99 -62 -12 -54 -61 13 -82 45 -14 77 -47 94 -97 24 -69 63 -73 83 -7 14 48 55 88 107 106 31 11 40 19 40 37 0 23 -2 25 -70 57 -31 15 -47 32 -70 78 -31 60 -41 70 -62 57z"/>
                    <path d="M1579 1205 c-12 -20 -40 -48 -61 -61 -45 -29 -47 -52 -5 -72 15 -7 35 -24 44 -38 50 -72 73 -76 98 -17 9 22 26 39 48 48 59 25 55 48 -17 98 -14 9 -31 29 -38 44 -20 41 -44 41 -69 -2z"/>
                    <path d="M474 1196 c-29 -29 -34 -41 -34 -79 0 -83 79 -142 155 -117 52 17 85 62 85 117 0 38 -5 50 -34 79 -30 30 -40 34 -86 34 -46 0 -56 -4 -86 -34z"/>
                  </g>
                </svg>
              </button>
            </div>
          )}

          <div
            onClick={goBack}
            className={`img-back ${isChangingCamera ? 'hiding' : ''}`}
            ref={imgBack}
          />

          <div className={isChangingCamera ? 'hiding' : ''}>
            <div
              ref={guideAdo}
              className={`guide-ado ${platform === "web" ? "margin-top-web" : ""} ${
                isMovil() ? "movil" : "desk"
              }`}
            >
              {configValue.styles.showGuide && <div className="dashed-marked" />}
              <video
                onClick={handleVideoTap}
                id="video-camera"
                className={`container-camera-movil video-movil ${isMovil() ? "movil" : "desk"}`}
                ref={videoRef}
                controls={false}
                autoPlay
                playsInline
                muted
                disablePictureInPicture
                disableRemotePlayback
                style={{
                  WebkitAppearance: "none",
                  appearance: "none",
                  pointerEvents: "auto"
                }}
              />
              {typeCapture === "1" ? (
                <div className="type-capture-1">
                  <div ref={textPreview} className="text-preview text-guide">
                    Ubíca la parte de adelante de tu documento
                  </div>
                </div>
              ) : (
                <div className="type-capture-2">
                  <div ref={textPreviewBack} className="text-preview-back text-guide">
                    Ubica la parte de adelante de tu documento
                  </div>
                </div>
              )}
            </div>

            <div
              ref={takeManual}
              onClick={!loading ? takeManualPhoto : undefined}
              className={`take-manual ${loading ? 'disabled' : ''}`}
              style={{
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.5 : 1
              }}
            >
              <div className="take-manual-inner" />
            </div>
          </div>

          <canvas id="canvas-view" className="canvas-view" ref={canvasRef} />
          <img alt="imgResult" id="imgResult" className="img-result" />
          <div id="message-alert-ado" className="message-alert-ado">
            <h2>Error al validar el documento</h2>
            <p>Verifique que el documento se vea correctamente</p>
          </div>
        </>
      )}
    </div>
  );
}
